import { useEffect } from "react"

export const ChangePageTitle = (title) => {
    useEffect(() => {
        document.title = title;
    }, [title])
}